export const experienceData = {
    "name": "Roman Surkov",
    "job-title": "Software engineer",
    "description": [
        "Experienced and results-oriented Java developer with a passion for delivering high-quality software solutions. With a strong track record of delivering successful projects across various industries, including banking software and government portals",
        "Throughout my career, I have demonstrated a passion for software development and a commitment to continuous learning and growth. I have successfully collaborated with cross-functional teams to streamline the software development process and enhance code quality. Skilled in team leadership, I have effectively managed and mentored junior developers, fostering a collaborative and productive work environment.",
        "I am driven by the challenge of solving complex problems and thrive in dynamic environments where I can apply my strong problem-solving skills and attention to detail. With a focus on delivering exceptional results, I am dedicated to surpassing customer expectations and driving business success.",
        "I am seeking a new opportunity where I can leverage my experience to contribute to the success of a promising company."
    ],
    "companies": {
        "Ey": {
            "name": "Ernst & Young",
            "url": "https://ey.com"
        },
        "It_one": {
            "name": "It-one",
            "url": "https://it-one.ru"
        },
        "AlfaBank": {
            "name": "Alfa-Bank",
            "url": "https://alfabank.ru"
        },
        "Colvir": {
            "name": "Colvir Software Solutions",
            "url": "https://colvir.com"
        },
        "Codemark": {
            "name": "Codemark",
            "url": "http://codemark.ru/"
        },
        "Skillbox": {
            "name": "Skillbox",
            "url": "https://skillbox.ru"
        },
        "Nipi": {
            "name": "NIPIGAZ (SIBUR Group)",
            "url": "https://www.nipigas.ru/"
        },
        "Sys": {
            "name": "System & networks",
            "url": null
        },
        "Ets": {
            "name": "Electrical systems",
            "url": "http://etsystem.ru/"
        },
        "Rostelecom": {
            "name": "Rostelecom",
            "url": "https://rt.ru"
        }
    },
    "experience": [
        {
            "period": {
                "started": "12.2023",
                "finished": null
            },
            "company": "AlfaBank",
            "position": "Lead software engineer",
            "description": [
                "Developed various solutions for a project managing biometric data of clients and employees: collection, storage, processing, and integration with other Bank systems and government agencies.",
                "Migrated all microservices to a modern technology stack.",
                "Developed several parts of functionality within tight deadlines to comply with rapidly changing legislation, enabling the Bank to retain licenses for working with biometrics.",
                "Significantly improved logging on the project, allowing the support team in the production environment to more effectively monitor and analyze events.",
                "Officially performed the functions of the team Scrum Master, conducting all necessary meetings and ensuring the relevance of tasks and the backlog."
            ]
        },
        {
            "period": {
                "started": "10.2021",
                "finished": "12.2023"
            },
            "company": "It_one",
            "position": "Senior software engineer",
            "description": [
                "Developed banking software for one of the largest banks in the country.",
                "Implemented a digital signature project for clients, attracting new partners and tripling the number of issued loans.",
                "Performed technical improvements that significantly reduced production time.",
                "Separated microservices, increased test coverage, and implemented new CI/CD processes."
            ]
        },
        {
            "period": {
                "started": "09.2020",
                "finished": "10.2021"
            },
            "company": "Colvir",
            "position": "Java developer",
            "description": [
                "Participated in maintaining the company's main product, banking software.",
                "Developed a service for receiving multicast data from the stock exchange in a multithreaded mode."
            ]
        },
        {
            "period": {
                "started": "07.2020",
                "finished": "09.2021"
            },
            "company": "Codemark",
            "position": "Programmer",
            "description": [
                "Developed the backend for a sports federation portal and an application for working with the database of a government electoral system.",
                "Implemented full-text search in PostgreSQL and developed functionality for mass creation of data records."
            ]
        }
    ],
    "not_relevant_experience": [
        {
            "period": {
                "started": "2018",
                "finished": "2019"
            },
            "company": "Nipi",
            "position": "Expert at reporting and planning department",
            "description": ""
        },
        {
            "period": {
                "started": "2017",
                "finished": "2018"
            },
            "company": "Rostelecom",
            "position": "Contractor at Nizhne-Bureyskaya HPP construction",
            "description": ""
        },
        {
            "period": {
                "started": "2015",
                "finished": "2017"
            },
            "company": "Ey",
            "position": "Contractor at Blagoveschenskaya TPP reconstruction",
            "description": ""
        },
        {
            "period": {
                "started": "2013",
                "finished": "2015"
            },
            "company": "Sys",
            "position": "Chief project engineer",
            "description": ""
        },
        {
            "period": {
                "started": "2009",
                "finished": "2013"
            },
            "company": "Ets",
            "position": "Lead design engineer",
            "description": ""
        }
    ],
    "engineering_experience": [
        {
            "period": {
                "started": "07.2009",
                "finished": "11.2019"
            },
            "company": "Ey / Nipi / Rostelecom / Sys / Ets",
            "position": "Chief project engineer / Lead design engineer / Contractor / Expert",
            "description": [
                "Monitored construction work and equipment delivery for the industrial infrastructure of the Amur Gas Processing Plant project as an expert.",
                "Led a design team of 15 members to develop engineering system design documentation for major projects like Bureyskaya HPP and Vostochny Spaceport."
            ]
        }
    ],
    "core-competencies": [
        "Java/Kotlin",
        "Teamwork",
        "OOP",
        "Confluence",
        "Kibana",
        "Spring&nbsp;Framework",
        "Docker",
        "Git",
        "Jira",
        "Liquibase",
        "JSON",
        "SQL",
        "Microservices",
        "Scrum",
        "Teamcity",
        "REST API",
        "SpringBoot",
        "CamundaBPM",
        "Bitbucket",
        "Gradle/Maven",
        "PostgreSQL",
        "MongoDB",
        "Kafka",
        "JUnit/Mockito"
    ],
    "certifications": [
        {
            "company": "Stepik",
            "date": "01.2024",
            "name": "Ansible for beginners + hands-on experience"
        },
        {
            "company": "Stepik",
            "date": "12.2023",
            "name": "Kubernetes for users"
        },
        {
            "company": "Specialist - Computer Training Center",
            "date": "06.2023",
            "name": "Refactoring as a systematic approach"
        },
        {
            "company": "Udemy",
            "date": "10.2023",
            "name": "FullStack: Angular and Java SpringBoot E-Commerce Website"
        },
        {
            "company": "IBS Training center",
            "date": "05.2023",
            "name": "Design patterns (GoF). Java edition. Technologies and Tools for Software and Information Systems Development"
        },
        {
            "company": "IBS Training center",
            "date": "12.2022",
            "name": "Java Efficiency. Technologies and Tools for Software and Information Systems Development"
        },
        {
            "company": "Mail.ru",
            "date": "04.2020",
            "name": "Development of a Web Service in Java"
        },
        {
            "company": "Geekbrains",
            "date": "05.2020",
            "name": "Java beginner, medium, advanced level tests"
        },
        {
            "company": "Fluent cities",
            "dateStart": "08.2018",
            "dateEnd": "05.2019",
            "name": "Business English Intermediate"
        },
        {
            "company": "Management Systems",
            "date": "08.2015",
            "name": "Project Management with Oracle Primavera, Basic Course"
        }
    ],
    "education": [
        {
            "company": "Amur State University",
            "additional": "Faculty of Power Engineering",
            "qualification": "Specialist degree in Engineering of Power Plants",
            "date_start": "08.2004",
            "date_end": "07.2009",
            "period": "5y"
        },
        {
            "company": "Skillbox",
            "qualification": "Student of the \"Java Developer\" course",
            "date_start": "07.2019",
            "date_end": "05.2020",
            "period": "11m"
        }
    ]
}